import React, { useEffect, useState } from 'react';
import { useOnResize } from '../../../../../../../../../../Foundation/React/code/Hooks/UseOnResize.jsx';
import { createPortal } from 'react-dom';
import { IsProductPage } from '../../../FitAssistantShared/IsProductPage.js';
import RoofTopTentButton from './RoofTopTentButton.tsx';

const RooftopTentPortalContainer = () => {
  const [isDOMReady, setIsDOMReady] = useState<boolean>(false);

  const portal = document.querySelector('#REACT_fitAssistant_rtt_portal');
  const mobilePortal = document.querySelector('#REACT_fitAssistant_rtt_portal_mobile');

  useEffect(() => {
    setIsDOMReady(true);
  }, []);

  const [width] = useOnResize();
  return (
    <>
      {IsProductPage && isDOMReady && portal ? createPortal(<RoofTopTentButton />, portal) : null}
      {!IsProductPage && isDOMReady && portal && mobilePortal
        ? createPortal(<RoofTopTentButton />, width <= 992 ? mobilePortal : portal)
        : null}
    </>
  );
};

export default RooftopTentPortalContainer;
